import React from "react";
import Headers from "./Headers";
import { Container, Row, Col } from "react-bootstrap";
import MerchCard from "./MerchCard";
import shirt1 from "../assets/shirt1.png";
import shirt2 from "../assets/shirt2.png";
import shirt3 from "../assets/shirt3.png";
import sweater1 from "../assets/sweater1.png";
import sweater2 from "../assets/sweater2.png";
import sweater3 from "../assets/sweater3.png";
import sweater4 from "../assets/sweater4.png";
import pant1 from "../assets/pant1.png";
import SEO from "./SEO";

export default function Merch() {
  const merchBody = [
    {
      img: shirt1,
      name: "WHITE BOXING SHIRT",
      price: "$25",
      desc: "white t-shirt",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&id=1892868&clear=1",
    },
    {
      img: shirt2,
      name: "BLACK BOXING SHIRT (CROPPED)",
      price: "$55",
      desc: "black t-shirt cropped",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893011",
    },
    {
      img: shirt3,
      name: "BOXING SHIRT GREY (CROPPED)",
      price: "$55",
      desc: "grey t-shirt cropped",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893015",
    },
    {
      img: sweater1,
      name: "BOXING SWEATER GREY (CROPPED)",
      price: "$90",
      desc: "white t-shirt cropped",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893016",
    },
    {
      img: sweater2,
      name: "BOXING SWEATER GREY",
      price: "$110",
      desc: "grey sweater",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893018",
    },
    {
      img: sweater3,
      name: "BOXING SWEATER BLACK",
      price: "$110",
      desc: "black sweater",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893019",
    },
    {
      img: sweater4,
      name: "BOXING SWEATER BLACK (CROPPED)",
      price: "$90",
      desc: "black sweater cropped",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893022",
    },
    {
      img: pant1,
      name: "BOXING SWEATPANTS BLACK",
      price: "$100",
      desc: "white t-shirt",
      link: "https://app.acuityscheduling.com/catalog.php?owner=26831882&action=addCart&clear=1&id=1893023",
    },
  ];

  return (
    <>
      <SEO title="Merch Gloves Up | Shop Toronto Boxing Gym Apparel" description="Represent the best boxing gym in Toronto with exclusive Gloves Up merch. From premium gym gear to everyday apparel, our shop has everything to keep you looking sharp." />
      <div className="merch" id="home">
        <h1 className="sr-only">Merch Gloves Up | Shop Toronto Boxing Gym Apparel</h1>
        <p className="sr-only">
          Shop official Gloves Up Boxing merch, featuring Toronto boxing gym apparel, gloves, and gear. Designed for members and fans of the Junction’s top boxing gym.
        </p>
        <Headers title={"Merch"} />
        <div className="merch-body">
          <Container className="d-flex justify-content-center">
            <Row className="d-flex justify-content-center">
              {merchBody.map((obj, index) => (
                <Col key={index} xxl={4} xl={4} lg={4} md={4} sm={6} xs={12}>
                  <MerchCard merchBody={obj} />
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
